/** Presentation — document knowledge definition. Pure data. */
export default {
  id: 'presentation',
  name: 'Presentation',
  description: 'A multi-slide deck that walks an audience through a narrative or proposal.',
  purpose: 'Communication & Persuasion',
  recommendedSizes: [{ name: '16:9 Slide', width: 1920, height: 1080, unit: 'px' }],
  supportedOrientations: ['landscape'],
  supportsMultiplePages: true,
  supportsBleed: false,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: true,
  supportsPricing: true,
  supportsCTA: true,
  supportsOffers: false,
  supportsTimeline: true,
  supportsGallery: true,
  typicalSections: ['Cover', 'Agenda', 'Slides', 'Charts', 'Summary'],
};
